module.exports = __webpack_public_path__ + "img/cateau.bae9ef45.jpg";